import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import { withRouter, Link as NavLink } from 'react-router-dom';
import { event } from '@minerva-analytics/pantheon';
import signActions from 'store/sign/actions';
import timeframeActions from 'store/timeframe/actions';
import categoryActions from 'store/category/actions';
import { ContentCard } from '../../styled_constants';

import { SIGN_MAPPING } from '../../utils/signs';

import {
  CurrentSignIcon,
  CurrentSignHeader,
  CurrentSign,
  ReadMoreButton,
  MobileButton,
  MobileCurrentSignDate,
  MobileColumns,
  SignSeasonContent,
} from './SignCard.styles';

const getCurrentSign = (day, month) => {
  if ((month === 1 && day <= 20) || (month === 12 && day >= 22)) {
    return `Capricorn`;
  } else if ((month === 1 && day >= 21) || (month === 2 && day <= 19)) {
    return `Aquarius`;
  } else if ((month === 2 && day >= 20) || (month === 3 && day <= 20)) {
    return `Pisces`;
  } else if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) {
    return `Aries`;
  } else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) {
    return `Taurus`;
  } else if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) {
    return `Gemini`;
  } else if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) {
    return `Cancer`;
  } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
    return `Leo`;
  } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
    return `Virgo`;
  } else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) {
    return `Libra`;
  } else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) {
    return `Scorpio`;
  } else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) {
    return `Sagittarius`;
  }
  return `Aries`;
};

export const SignCard = (props) => {
  const newDate = new Date();
  const currentDay = newDate.getDate();
  const currentMonth = newDate.getMonth() + 1;
  const currentSign = getCurrentSign(currentDay, currentMonth);
  const sign = currentSign.toLowerCase();

  useEffect(() => {
    props.selectSign({ id: sign });
    props.selectCategory({ id: `life` });
    props.selectTimeframe({ id: `daily` });
  });

  return (
    <ContentCard>
      <CurrentSignHeader>
        It&apos;s <CurrentSign>{currentSign}</CurrentSign> Season!
      </CurrentSignHeader>
      <SignSeasonContent>
        <MobileColumns>
          <LazyLoad once height={150}>
            <CurrentSignIcon src={ SIGN_MAPPING[sign].starImage } alt={`${currentSign} Icon`} />
          </LazyLoad>
          <MobileButton>
            <MobileCurrentSignDate>
              {SIGN_MAPPING[sign].date}
            </MobileCurrentSignDate>
            <NavLink to={ `/life/daily/${sign}` }>
              <ReadMoreButton
                type="submit"
                onClick={() => {
                  event([`click`, `hero-season`, sign]);
                }}
              >
                Read horoscope
              </ReadMoreButton>
            </NavLink>
          </MobileButton>
        </MobileColumns>
      </SignSeasonContent>
    </ContentCard>
  );
};


SignCard.propTypes = {
  selectSign: PropTypes.func.isRequired,
  selectTimeframe: PropTypes.func.isRequired,
  selectCategory: PropTypes.func.isRequired,
};

export default connect(() => ({}), {
  selectSign: signActions.selectSign,
  selectTimeframe: timeframeActions.selectTimeframe,
  selectCategory: categoryActions.selectCategory,
})(withRouter(SignCard));
